module.exports = __webpack_public_path__ + "img/96.64bbd1f1.webp";